/**
 * IndeterminateBar — small inline progress indicator matching the app's
 * sync status bar aesthetic (gradient shimmer, not a spinning circle).
 *
 * Used in login submit, toasts, and other places that previously used
 * SpinnerIcon + animate-spin.
 */

import { cn } from "@/shared/utils/general/cn"

interface IndeterminateBarProps {
  className?: string
  /** Fade the edges for a softer look. Default true. Set false for full-width bars. */
  softEdges?: boolean
}

export function IndeterminateBar({ className, softEdges = true }: IndeterminateBarProps) {
  return (
    <div
      className={cn(
        "relative h-1 w-16 overflow-hidden rounded-full",
        className,
      )}
      style={softEdges ? {
        maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
        WebkitMaskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
      } : undefined}
    >
      <div
        className="absolute top-0 bottom-0 animate-indeterminate-bar1"
        style={{
          background: "linear-gradient(to right, transparent 0%, var(--primary) 50%, transparent 100%)",
          opacity: 0.7,
        }}
      />
      <div
        className="absolute top-0 bottom-0 animate-indeterminate-bar2"
        style={{
          background: "linear-gradient(to right, transparent 0%, var(--primary) 50%, transparent 100%)",
          opacity: 0.7,
        }}
      />
    </div>
  )
}
